import styled, { css } from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

export const CallTextInputWrapper = styled.div`
  ${({ $disabled, theme: { color, borderRadius, spacing } }) => css`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-radius: ${borderRadius.sm};
    padding: ${spacing.sm} ${spacing.p3};
    display: flex;
    gap: ${spacing.md};
    border: 1px solid ${color.blue30};
    background: rgb(255, 255, 255);
    :focus-within {
      border: 1px solid ${color.blue};
    }
    margin-top: ${spacing.lg};
    height: 68px;
    ${!$disabled &&
    css`
      cursor: text;
    `}
  `}
`;

export const CallTextInput = styled(TextareaAutosize)`
  border: none;
  resize: none;
  background: none;
  flex: 1;
  font-size: 1rem;
  outline: none;
`;
